import { formatISO, isValid, parseISO } from "date-fns";
import type { ValidationResult } from "@entrilia/shared/utilities/validators";
import type { EntityFieldComponentPropsBase } from "../entityFieldTypes";
import EntityDateTimeFieldValueComponent from "./EntityDateTimeFieldValueComponent";

const minDateString = "0001-01-01"; // Used to indicate an empty date value on the backend

const getValidDateValue = (value: unknown): Date | null => {
  const isMinDate = (date: Date): boolean => date.getFullYear() === 1 && date.getMonth() === 0 && date.getDate() === 1;
  const date = value instanceof Date ? value : typeof value === "string" ? parseISO(value) : null;
  return date && isValid(date) && !isMinDate(date) ? date : null;
};

const EntityDateTimeField = ({
  value,
  fieldId,
  fieldAttributes,
  onChange,
  fieldInputId,
}: EntityFieldComponentPropsBase) => {
  const date = getValidDateValue(value);

  const handleChange = (newValue: Date | null, validationResult: ValidationResult) => {
    const dateISOString = newValue ? formatISO(newValue) : minDateString;
    onChange(dateISOString, fieldId, validationResult);
  };

  return (
    <EntityDateTimeFieldValueComponent
      value={date}
      fieldAttributes={fieldAttributes}
      onChange={handleChange}
      fieldInputId={fieldInputId}
    />
  );
};

export default EntityDateTimeField;
